var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLimones(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 251,
    height: 149,
    viewBox: "0 0 251 149",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    transform: "translate(110 741)",
    width: 251,
    height: 149,
    fill: "none",
    stroke: "#707070"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.381.132A8.688,8.688,0,0,1,72.011,3.5c.038.053.077.108.114.162A8.751,8.751,0,0,1,73.41,9.95c-.349,2.156-1.676,3.771-2.456,5.752a19.861,19.861,0,0,1-1.046,2.348c-.356.649-.743,1.286-1.144,1.907-.474.734-.327,1.125-.163,1.937.124.617.235,1.234.342,1.853a68.482,68.482,0,0,1,.873,7.4c.5,8.119-.6,16.636-4.779,23.746A28.166,28.166,0,0,1,48.7,67.572c-8.341,2.492-17.368,1.6-25.65-.676-.147-.041-.732.379-.881.456l-.811.418q-.719.37-1.44.729c-.764.379-1.535.748-2.326,1.067a12.943,12.943,0,0,1-4.071.933c-.913.058-1.774-.155-2.67-.1a21.006,21.006,0,0,1-4.184-.082A8.274,8.274,0,0,1,2.05,68.239C-.177,66.078-.451,62.482.564,59.55a16.62,16.62,0,0,1,2.281-4.221c.465-.648.96-1.272,1.468-1.888A8.911,8.911,0,0,0,5.8,51.519C5.623,49.265,5.92,46,5.05,43.078A27.107,27.107,0,0,1,4.04,33.2,31.335,31.335,0,0,1,6.926,22.487a35.357,35.357,0,0,1,6.387-9.346,34.778,34.778,0,0,1,9.12-6.909,31.468,31.468,0,0,1,11.085-3.4,14.407,14.407,0,0,0,1.517-.144c.453-.1.84-.316,1.312-.39A20.7,20.7,0,0,1,47.694,3.746c2.112.919,4.3,2.227,6.552,1.746,2.31-.491,3.8-2.682,5.731-4.036A8.686,8.686,0,0,1,66.381.132Z",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    transform: "translate(-1248.3 -1224.6)",
    d: "M1305.613,1224.677a7.5,7.5,0,0,1,4.864,2.907c.033.046.066.093.1.14a7.559,7.559,0,0,1,1.11,5.434c-.3,1.862-1.448,3.258-2.121,4.969a17.171,17.171,0,0,1-.9,2.028c-.308.56-.641,1.111-.988,1.648-.41.634-.282.972-.141,1.673.107.532.2,1.066.3,1.6a59.164,59.164,0,0,1,.754,6.391c.429,7.013-.518,14.37-4.128,20.513a24.332,24.332,0,0,1-14.11,10.953c-7.205,2.152-15,1.379-22.157-.584-.127-.035-.632.327-.761.394l-.7.361q-.621.319-1.244.63c-.66.327-1.326.646-2.009.922a11.183,11.183,0,0,1-3.517.806c-.789.05-1.532-.134-2.306-.09a18.149,18.149,0,0,1-3.614-.071,7.147,7.147,0,0,1-3.991-1.792c-1.923-1.867-2.16-4.973-1.283-7.506a14.357,14.357,0,0,1,1.97-3.646c.4-.559.83-1.1,1.268-1.63a7.7,7.7,0,0,0,1.283-1.661c-.152-1.947.1-4.77-.647-7.292a23.414,23.414,0,0,1-.872-8.53,27.067,27.067,0,0,1,2.493-9.256,30.541,30.541,0,0,1,5.517-8.073,30.041,30.041,0,0,1,7.878-5.969,27.182,27.182,0,0,1,9.576-2.941,12.469,12.469,0,0,0,1.311-.124c.391-.088.726-.273,1.133-.337a17.644,17.644,0,0,1,3.349-.2,17.823,17.823,0,0,1,6.453,1.452c1.824.793,3.714,1.924,5.659,1.509,2-.424,3.279-2.317,4.951-3.487A7.5,7.5,0,0,1,1305.613,1224.677Z",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-110 -741)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 795.68)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.623,0H218.564c3.658,0,6.623,3.378,6.623,7.546L192.072,86.777c0,4.167-2.965,7.546-6.623,7.546H39.739c-3.658,0-6.623-3.378-6.623-7.546L0,7.546C0,3.378,2.965,0,6.623,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.6232 3c-0.89307 0-1.7556 0.42231-2.4286 1.1891-0.66112 0.75321-1.0673 1.7381-1.1692 2.8157l32.858 78.615 0.23207 0.55518v0.60172c0 1.287 0.42421 2.479 1.1946 3.3567 0.67303 0.76678 1.5355 1.1891 2.4286 1.1891h145.71c0.89307 0 1.7556-0.42231 2.4286-1.1891 0.77031-0.87762 1.1946-2.0697 1.1946-3.3567v-0.60172l0.23206-0.55518 32.858-78.615c-0.1019-1.0776-0.5081-2.0625-1.1692-2.8156-0.67307-0.76682-1.5356-1.1891-2.4286-1.1891h-211.94m0-3h211.94c3.6579 0 6.6232 3.3784 6.6232 7.5458l-33.116 79.231c0 4.1674-2.9653 7.5458-6.6232 7.5458h-145.71c-3.6579 0-6.6232-3.3784-6.6232-7.5458l-33.116-79.231c0-4.1674 2.9653-7.5458 6.6232-7.5458z",
    fill: "#20201d"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#eddd36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1063.4 -331.76)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1244.8 1179.1c-0.48962 0-0.93042-0.039673-1.3192-0.074829-0.297-0.026733-0.55334-0.049805-0.76562-0.049805-0.045166 0-0.085693 9.7656e-4 -0.12378 0.0031738-0.58301 0.032593-1.3507 0.069946-2.1351 0.069946-0.99036 0-1.8761-0.058472-2.7079-0.17883-2.5647-0.36987-4.76-1.38-6.3473-2.921-1.5426-1.4971-2.5339-3.5171-2.8667-5.8412-0.28699-2.0048-0.074463-4.1166 0.61462-6.1073 0.57263-1.6547 1.4601-3.3066 2.713-5.0498 0.46155-0.64185 0.98914-1.3207 1.6132-2.0756 0.18677-0.22583 0.37695-0.43469 0.5448-0.61902 0.067993-0.074585 0.1488-0.16333 0.22717-0.25183-0.014526-0.44324-0.02124-0.90015-0.028076-1.3716-0.025879-1.7853-0.055298-3.8088-0.55994-5.5024-1.0604-3.5634-1.4438-7.3022-1.1399-11.114 0.3219-4.0352 1.3984-8.0385 3.2-11.899 1.7545-3.7593 4.1169-7.2173 7.0216-10.278 2.9521-3.1113 6.3302-5.6702 10.04-7.605 3.9069-2.0375 8.0468-3.3076 12.305-3.7751 0.2655-0.029175 0.51062-0.042603 0.72681-0.054443 0.16797-0.0092773 0.396-0.021851 0.48474-0.037964 0.044678-0.012573 0.15259-0.051147 0.2323-0.079712 0.3136-0.11218 0.74304-0.26575 1.2864-0.35156l0.0032959-4.8828e-4 0.0031738-4.8828e-4c1.194-0.18567 2.4203-0.27979 3.6449-0.27979 0.28345 0 0.57104 0.0050049 0.85486 0.015015 3.0176 0.10779 5.9332 0.76489 8.6675 1.9532 0.38147 0.16565 0.75696 0.33911 1.1201 0.50684 1.1921 0.55066 2.4248 1.12 3.3264 1.1201 0.13513 0 0.2594-0.012451 0.37988-0.038086 0.75171-0.16052 1.6158-0.95288 2.5306-1.7919 0.63904-0.58594 1.3633-1.2501 2.1868-1.8264 1.8862-1.3215 4.1735-2.0206 6.6133-2.0206 0.70056 0 1.408 0.059448 2.1027 0.17676 3.1241 0.52588 5.9116 2.209 7.6465 4.6176l0.0068359 0.0093994 0.0067139 0.0095215 0.017944 0.025269c0.03772 0.053223 0.084351 0.11865 0.13611 0.19568 1.623 2.3892 2.2714 5.5013 1.7784 8.5405-0.30237 1.8677-1.0859 3.3406-1.7772 4.6401-0.3363 0.6322-0.65393 1.2294-0.88367 1.8132-0.30969 0.78735-0.69543 1.7678-1.2245 2.7289-0.30798 0.5614-0.64905 1.1384-1.0355 1.7521 0.0074463 0.036377 0.015015 0.073486 0.022705 0.11133 0.11438 0.56799 0.22949 1.192 0.36194 1.9623 0.45947 2.6814 0.77002 5.3156 0.92322 7.8311 0.28455 4.653 0.052979 9.0765-0.68811 13.147-0.85291 4.6847-2.3898 8.939-4.568 12.645-4.0238 6.8445-10.522 11.893-18.298 14.215-3.6505 1.0906-7.6171 1.6436-11.789 1.6437-4.615 1.2207e-4 -9.568-0.67444-14.739-2.0062-0.1084 0.05603-0.21594 0.11133-0.32349 0.16675-0.12146 0.0625-0.2428 0.125-0.36401 0.18774l-0.0061035 0.0031738-0.0061035 0.0030518c-0.44507 0.22778-0.97046 0.49561-1.4941 0.75537-0.79065 0.39221-1.6492 0.8064-2.5687 1.1777-1.639 0.66077-3.3423 1.0505-5.0643 1.1591-0.16943 0.01062-0.34338 0.015869-0.51917 0.015869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1297.1 1104.6c-1.7369 0-3.4635 0.47681-4.8931 1.4785-1.9626 1.3735-3.4707 3.5947-5.8135 4.0947-0.3363 0.071533-0.67078 0.10364-1.0042 0.10364-1.9315 0-3.8153-1.082-5.6421-1.8755-2.3894-1.0385-4.976-1.6135-7.5775-1.7064-0.24951-0.0087891-0.49927-0.013184-0.74915-0.013184-1.0651 0-2.1309 0.080444-3.1837 0.24414-0.47815 0.075439-0.87134 0.29272-1.3308 0.39563-0.49353 0.10925-1.0371 0.091675-1.5396 0.14673-3.9248 0.43091-7.7471 1.6288-11.245 3.4531-3.4479 1.7981-6.577 4.1914-9.2515 7.0101-2.6454 2.7874-4.8529 5.9969-6.4791 9.4813-1.5944 3.4165-2.6278 7.1055-2.928 10.869-0.26855 3.3677 0.060425 6.7791 1.0245 10.019 0.88257 2.962 0.5813 6.2767 0.75989 8.5619-0.31775 0.7373-0.99719 1.3348-1.5068 1.9513-0.51501 0.62292-1.0171 1.2582-1.4893 1.9149-0.94934 1.3208-1.7805 2.7384-2.3141 4.2803-1.0298 2.9746-0.75208 6.6222 1.5067 8.8146 1.2494 1.2129 2.9631 1.8557 4.6874 2.1044 0.75586 0.10938 1.5165 0.14795 2.2782 0.14795 0.65552 0 1.3118-0.028564 1.9658-0.065186 0.098145-0.0054932 0.19568-0.0079346 0.29309-0.0079346 0.6969 0 1.3781 0.12463 2.0847 0.12463 0.1095 0 0.2196-0.0029297 0.33044-0.0098877 1.4326-0.090332 2.8-0.41064 4.1296-0.94666 0.80237-0.3241 1.5846-0.69946 2.3593-1.0837 0.48853-0.24231 0.97449-0.48962 1.4603-0.73828 0.2738-0.14172 0.54883-0.28235 0.82239-0.42432 0.14514-0.075562 0.69214-0.46594 0.87146-0.46594 0.0084229 0 0.016113 8.5449e-4 0.022827 0.0026855 4.8701 1.337 9.9935 2.2036 15.089 2.2036 3.6945 0 7.3746-0.45581 10.931-1.5182 6.9574-2.078 12.883-6.5881 16.57-12.861 4.2402-7.2136 5.3514-15.855 4.8479-24.089-0.1532-2.5164-0.45972-5.0214-0.88538-7.505-0.10791-0.62769-0.22083-1.2556-0.34656-1.8798-0.16541-0.82349-0.31494-1.2203 0.16602-1.9648 0.40662-0.63159 0.79846-1.2772 1.16-1.9362 0.4231-0.76855 0.74084-1.567 1.0609-2.3807 0.79114-2.0103 2.1373-3.649 2.4912-5.835 0.35535-2.191-0.043701-4.5316-1.3032-6.3811-0.03772-0.056396-0.076538-0.11035-0.11572-0.16565-1.3395-1.8596-3.4592-3.0337-5.7117-3.4128-0.52991-0.089478-1.067-0.13489-1.6034-0.13489m0-6c0.87048 0 1.7423 0.073364 2.6024 0.21863 3.895 0.65564 7.3883 2.778 9.5812 5.8223 2.2621 3.3137 3.0883 7.2207 2.473 11.014-0.38171 2.3575-1.3289 4.1381-2.09 5.5687-0.25989 0.48877-0.53296 0.9751-0.74072 1.5029-0.41418 1.0531-0.83972 2.0813-1.3878 3.077-0.1637 0.29822-0.33301 0.59521-0.50696 0.8905l0.18445 0.9801c0.46301 2.7014 0.79468 5.4231 0.96106 8.157 0.65637 10.733-1.2494 19.984-5.6642 27.494-4.4094 7.5002-11.521 13.03-20.026 15.57-3.9294 1.174-8.1851 1.7692-12.648 1.7692-4.5334 0-9.3597-0.61292-14.376-1.8239l-1.2239 0.62122c-0.91162 0.45215-1.8339 0.89038-2.7782 1.2719-1.9392 0.78186-3.9564 1.2427-5.9993 1.3716-0.24133 0.0041504-0.45569 0.0061035-0.64832 0.0061035-0.80054 0-1.225-0.033081-1.6481-0.071289-1.2198 0.0036621-1.988 0.0354-2.7552 0.0354-1.0492 0-2.0964-0.059204-3.1375-0.20984-3.1934-0.46045-5.9634-1.7531-8.0074-3.7374-3.7368-3.627-4.9135-9.5474-2.9972-15.083 0.66882-1.933 1.6869-3.8367 3.1118-5.8192 0.55151-0.76709 1.1361-1.5093 1.7371-2.2362l0.061157 0.028809c-0.0015869-0.10449-0.0031738-0.20996-0.0047607-0.31616-0.024292-1.6685-0.049316-3.3937-0.4353-4.6893-1.1667-3.9203-1.5889-8.0273-1.2554-12.209 0.35034-4.3933 1.5184-8.7433 3.4718-12.929 1.8916-4.053 4.4365-7.7789 7.5642-11.074 3.1807-3.3523 6.8243-6.1112 10.829-8.1998 4.2383-2.2103 8.7349-3.5889 13.365-4.0972 0.025269-0.0028076 1.1218-0.081421 1.1472-0.083862 0.35254-0.1261 1.0731-0.36279 1.443-0.42114 1.3706-0.21313 2.7451-0.31738 4.1187-0.31738 4.3562 0.13818 7.6383 0.8783 10.718 2.2168l1.1827 0.53491c0.69165 0.31946 1.7369 0.80237 2.1195 0.84546-0.26746-0.035156 0.39392-0.6416 0.83154-1.043 0.80286-0.73621 1.6201-1.4615 2.4943-2.0732 2.3918-1.6759 5.2744-2.5627 8.3333-2.5627z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(180.24 823.65) rotate(10)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m12.358 69.018c-0.46241 0-0.87474-0.037186-1.2385-0.069984-0.26848-0.024223-0.50035-0.045128-0.68582-0.045128-0.036871 0-0.07093 8.6975e-4 -0.10122 0.0025711-0.54156 0.030296-1.2544 0.064941-1.984 0.064941-0.92534 1.5259e-5 -1.7537-0.054771-2.5325-0.1675-2.4154-0.34829-4.4859-1.3023-5.9862-2.7588-1.4607-1.4178-2.3992-3.3282-2.7137-5.5244-0.27015-1.8866-0.070412-3.8732 0.57764-5.7452 0.53613-1.549 1.3653-3.0931 2.5347-4.7202 0.42964-0.59737 0.91964-1.2278 1.4986-1.928 0.17582-0.2127 0.35347-0.40779 0.51021-0.57989 0.044369-0.048725 0.09508-0.10441 0.14647-0.16166-0.011456-0.38168-0.01715-0.77383-0.02301-1.1773-0.023694-1.6329-0.050553-3.4837-0.50727-5.0163-0.98699-3.3168-1.3439-6.796-1.061-10.342 0.29936-3.7523 1.3001-7.474 2.9745-11.062 1.6298-3.4921 3.8243-6.7044 6.5226-9.5475 2.7421-2.8902 5.8805-5.2674 9.3276-7.065 3.6316-1.8939 7.4802-3.0746 11.439-3.5092 0.25133-0.027529 0.48075-0.040141 0.68315-0.051271 0.13962-0.007682 0.32765-0.018024 0.40887-0.030155 0.041809-0.013003 0.1252-0.04284 0.18805-0.065316 0.28129-0.10061 0.70638-0.25266 1.2294-0.33512l0.0030975-4.9412e-4 0.0030823-4.8232e-4c1.114-0.17325 2.258-0.26109 3.4003-0.26109 0.26415 0 0.53217 0.0047294 0.79661 0.014071 2.8142 0.10051 5.5336 0.71341 8.0838 1.8218 0.35467 0.15405 0.7026 0.31475 1.0391 0.47018 1.0774 0.49766 2.1915 1.0123 2.9727 1.0123 0.10852 0 0.20755-0.0098469 0.30279-0.030094 0.63204-0.13491 1.4071-0.84567 2.2277-1.5982 0.59498-0.54561 1.2694-1.164 2.0418-1.7046 1.78-1.2472 3.937-1.9068 6.2365-1.9068 0.65946 0 1.3254 0.055965 1.9792 0.16636 2.9429 0.4954 5.5702 2.0828 7.2067 4.3548l0.0070801 0.0098236 0.0069962 0.009894 0.016357 0.023059c0.042664 0.060112 0.084656 0.11982 0.12611 0.18131 1.5322 2.2538 2.1446 5.1882 1.68 8.0521-0.2851 1.7616-1.0179 3.1391-1.6645 4.3544-0.30718 0.57745-0.59734 1.1229-0.8046 1.6495-0.28819 0.73275-0.64719 1.6455-1.1426 2.5455-0.27306 0.4977-0.57413 1.0088-0.91338 1.5503 8.7738e-4 0.0043545 0.0017548 0.0087128 0.0026321 0.01309 0.1059 0.52546 0.21255 1.1035 0.33524 1.8171 0.42564 2.4838 0.7132 4.9235 0.85499 7.253 0.26373 4.3131 0.048965 8.4146-0.63836 12.19-0.79212 4.3507-2.2201 8.3028-4.2443 11.746-3.7436 6.3678-9.7887 11.064-17.022 13.225-3.3908 1.013-7.0742 1.5267-10.948 1.5268-4.2535 9.1553e-5 -8.8153-0.61754-13.576-1.8371-0.076199 0.039322-0.15227 0.078491-0.22835 0.11766-0.10931 0.056267-0.21862 0.11255-0.32775 0.16904l-0.0060711 0.0031357-0.0060825 0.0031204c-0.40972 0.20972-0.89426 0.45668-1.3815 0.69839-0.73471 0.36434-1.5321 0.74894-2.3871 1.0943-1.536 0.61926-3.1323 0.98446-4.7464 1.0862-0.1614 0.01004-0.32653 0.015045-0.49331 0.015045z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.673-1.1444e-4c-1.6032 0-3.1968 0.44015-4.5163 1.3647-1.8114 1.2677-3.2034 3.3178-5.3657 3.7794-0.31023 0.065964-0.61912 0.095688-0.92675 0.095688-1.7829 0-3.5214-0.99873-5.2075-1.7311-2.2054-0.95849-4.5928-1.4892-6.9939-1.575-0.23019-0.0081253-0.46037-0.012199-0.6908-0.012199-0.98315 1.1444e-5 -1.9673 0.074291-2.9392 0.22544-0.44128 0.069584-0.8042 0.27015-1.2283 0.36512-0.45555 0.10083-0.95726 0.084648-1.421 0.13543-3.6224 0.39771-7.1504 1.5034-10.379 3.1871-3.1822 1.6595-6.0704 3.8685-8.5388 6.4702-2.4416 2.5726-4.4792 5.535-5.9801 8.751-1.4717 3.1534-2.4254 6.5582-2.7025 10.032-0.24792 3.1083 0.055786 6.2568 0.94555 9.247 0.81469 2.7339 0.53662 5.7933 0.70142 7.9025-0.29321 0.68054-0.92041 1.2321-1.3907 1.801-0.47536 0.57495-0.93873 1.1612-1.3746 1.7673-0.87621 1.2191-1.6433 2.5276-2.1359 3.9507-0.95043 2.7455-0.6941 6.1121 1.3907 8.1356 1.1532 1.1195 2.7349 1.7128 4.3263 1.9423 0.69763 0.10098 1.3997 0.13656 2.1027 0.13656 0.60501 0 1.2108-0.026375 1.8145-0.060143 0.090637-0.005127 0.18074-0.00737 0.27069-0.00737 0.64328 0 1.2719 0.11512 1.9243 0.11512 0.10088 0 0.20246-0.0027618 0.30463-0.0091171 1.3223-0.083366 2.5844-0.37901 3.8115-0.87377 0.7406-0.29919 1.4625-0.64563 2.1776-1.0002 0.45081-0.22363 0.89941-0.45191 1.3478-0.6814 0.2528-0.13086 0.50659-0.26061 0.75903-0.39172 0.13404-0.069702 0.6388-0.42998 0.80431-0.42998 0.0078278 0 0.014904 8.049e-4 0.021141 0.0024872 4.4951 1.234 9.2238 2.0338 13.927 2.0338 3.4098 0 6.8066-0.42068 10.089-1.4013 6.4215-1.918 11.89-6.0807 15.294-11.871 3.9136-6.658 4.9392-14.634 4.4745-22.234-0.14135-2.3225-0.42432-4.6345-0.81714-6.9269-0.099617-0.57935-0.20386-1.1589-0.31995-1.735-0.15258-0.76014-0.29065-1.1263 0.1532-1.8135 0.37537-0.58302 0.73706-1.1788 1.0708-1.7871 0.39051-0.70935 0.68372-1.4463 0.97913-2.1974 0.73023-1.8554 1.9728-3.3679 2.2993-5.3855 0.328-2.0222-0.040276-4.1826-1.2028-5.8896-0.03492-0.052063-0.070671-0.10186-0.10681-0.15289-1.2363-1.7164-3.1929-2.8-5.2718-3.15-0.48908-0.082573-0.98478-0.1245-1.4797-0.1245m-7.6294e-6 -6c0.82906 0 1.6594 0.069908 2.4786 0.20821 3.7142 0.62526 7.0472 2.6518 9.1416 5.5596 2.1608 3.1652 2.9503 6.893 2.3636 10.51-0.36437 2.2513-1.2966 4.0036-1.9772 5.2831-0.23178 0.43569-0.47636 0.8686-0.66158 1.3392-0.38948 0.99026-0.79052 1.957-1.3061 2.8936-0.12543 0.22861-0.25449 0.45649-0.38663 0.68344l0.13966 0.7418c0.43017 2.5104 0.73823 5.0391 0.89283 7.5791 0.61142 9.9992-1.1686 18.626-5.2908 25.639-4.1291 7.0236-10.788 12.201-18.75 14.579-3.6698 1.0963-7.6421 1.6522-11.806 1.6522-4.1708 0-8.6049-0.5565-13.211-1.6564l-0.98159 0.49816c-0.8525 0.42277-1.7142 0.83195-2.5964 1.1884-1.8362 0.74031-3.7464 1.1767-5.6815 1.2987-0.23511 0.0041428-0.44336 0.0060272-0.62994 0.0060272-0.75898 0-1.1602-0.031075-1.5601-0.067131-1.0672 0.0050125-1.7849 0.034508-2.5016 0.034508-0.99055 0-1.9793-0.056168-2.9622-0.19843-3.044-0.43896-5.6891-1.6754-7.6462-3.5753-3.5772-3.472-4.7083-9.1259-2.8813-14.403 0.63251-1.8274 1.5921-3.6232 2.9336-5.4896 0.49931-0.69423 1.0267-1.3659 1.569-2.0239-1.4496e-4 -0.0095406-2.8229e-4 -0.019066-4.1962e-4 -0.028622-0.021896-1.5085-0.04454-3.0684-0.38264-4.203-1.0932-3.6738-1.4888-7.5212-1.1764-11.438 0.32791-4.1104 1.4202-8.1787 3.2465-12.092 1.7668-3.7857 4.1438-7.2659 7.0652-10.344 2.9706-3.1311 6.3745-5.7084 10.116-7.6598 3.9631-2.0668 8.1682-3.3558 12.499-3.8313 0.036968-0.0040436 1.029-0.074722 1.066-0.078094 0.097847-0.11401 0.67397-0.28578 1.3035-0.38506 1.2893-0.20052 2.5821-0.29867 3.8737-0.29868 4.0948 0.12994 7.1804 0.82585 10.076 2.0844l1.1014 0.49811c0.49439 0.22837 1.1988 0.55376 1.6124 0.68691-0.10337-0.14076 0.3102-0.51998 0.60519-0.7905 0.75597-0.69323 1.5262-1.3754 2.3492-1.9514 2.2858-1.6015 5.038-2.449 7.9567-2.449z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.602 -.799 .799 .602 -1397.4 1216.9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1244.8 1179.1c-0.48962 0-0.93042-0.039673-1.3192-0.074829-0.297-0.026733-0.55334-0.049805-0.76562-0.049805-0.045166 0-0.085693 9.7656e-4 -0.12378 0.0031738-0.58301 0.032593-1.3507 0.069946-2.1351 0.069946-0.99036 0-1.8761-0.058472-2.7079-0.17883-2.5647-0.36987-4.76-1.38-6.3473-2.921-1.5426-1.4971-2.5339-3.5171-2.8667-5.8412-0.28699-2.0048-0.074463-4.1166 0.61462-6.1073 0.57263-1.6547 1.4601-3.3066 2.713-5.0498 0.46155-0.64185 0.98914-1.3207 1.6132-2.0756 0.18677-0.22583 0.37695-0.43469 0.5448-0.61902 0.067993-0.074585 0.1488-0.16333 0.22717-0.25183-0.014526-0.44324-0.02124-0.90015-0.028076-1.3716-0.025879-1.7853-0.055298-3.8088-0.55994-5.5024-1.0604-3.5634-1.4438-7.3022-1.1399-11.114 0.3219-4.0352 1.3984-8.0385 3.2-11.899 1.7545-3.7593 4.1169-7.2173 7.0216-10.278 2.9521-3.1113 6.3302-5.6702 10.04-7.605 3.9069-2.0375 8.0468-3.3076 12.305-3.7751 0.2655-0.029175 0.51062-0.042603 0.72681-0.054443 0.16797-0.0092773 0.396-0.021851 0.48474-0.037964 0.044678-0.012573 0.15259-0.051147 0.2323-0.079712 0.3136-0.11218 0.74304-0.26575 1.2864-0.35156l0.0032959-4.8828e-4 0.0031738-4.8828e-4c1.194-0.18567 2.4203-0.27979 3.6449-0.27979 0.28345 0 0.57104 0.0050049 0.85486 0.015015 3.0176 0.10779 5.9332 0.76489 8.6675 1.9532 0.38147 0.16565 0.75696 0.33911 1.1201 0.50684 1.1921 0.55066 2.4248 1.12 3.3264 1.1201 0.13513 0 0.2594-0.012451 0.37988-0.038086 0.75171-0.16052 1.6158-0.95288 2.5306-1.7919 0.63904-0.58594 1.3633-1.2501 2.1868-1.8264 1.8862-1.3215 4.1735-2.0206 6.6133-2.0206 0.70056 0 1.408 0.059448 2.1027 0.17676 3.1241 0.52588 5.9116 2.209 7.6465 4.6176l0.0068359 0.0093994 0.0067139 0.0095215 0.017944 0.025269c0.03772 0.053223 0.084351 0.11865 0.13611 0.19568 1.623 2.3892 2.2714 5.5013 1.7784 8.5405-0.30237 1.8677-1.0859 3.3406-1.7772 4.6401-0.3363 0.6322-0.65393 1.2294-0.88367 1.8132-0.30969 0.78735-0.69543 1.7678-1.2245 2.7289-0.30798 0.5614-0.64905 1.1384-1.0355 1.7521 0.0074463 0.036377 0.015015 0.073486 0.022705 0.11133 0.11438 0.56799 0.22949 1.192 0.36194 1.9623 0.45947 2.6814 0.77002 5.3156 0.92322 7.8311 0.28455 4.653 0.052979 9.0765-0.68811 13.147-0.85291 4.6847-2.3898 8.939-4.568 12.645-4.0238 6.8445-10.522 11.893-18.298 14.215-3.6505 1.0906-7.6171 1.6436-11.789 1.6437-4.615 1.2207e-4 -9.568-0.67444-14.739-2.0062-0.1084 0.05603-0.21594 0.11133-0.32349 0.16675-0.12146 0.0625-0.2428 0.125-0.36401 0.18774l-0.0061035 0.0031738-0.0061035 0.0030518c-0.44507 0.22778-0.97046 0.49561-1.4941 0.75537-0.79065 0.39221-1.6492 0.8064-2.5687 1.1777-1.639 0.66077-3.3423 1.0505-5.0643 1.1591-0.16943 0.01062-0.34338 0.015869-0.51917 0.015869z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1297.1 1104.6c-1.7369 0-3.4635 0.47681-4.8931 1.4785-1.9626 1.3735-3.4707 3.5947-5.8135 4.0947-0.3363 0.071533-0.67078 0.10364-1.0042 0.10364-1.9315 0-3.8153-1.082-5.6421-1.8755-2.3894-1.0385-4.976-1.6135-7.5775-1.7064-0.24951-0.0087891-0.49927-0.013184-0.74915-0.013184-1.0651 0-2.1309 0.080444-3.1837 0.24414-0.47815 0.075439-0.87134 0.29272-1.3308 0.39563-0.49353 0.10925-1.0371 0.091675-1.5396 0.14673-3.9248 0.43091-7.7471 1.6288-11.245 3.4531-3.4479 1.7981-6.577 4.1914-9.2515 7.0101-2.6454 2.7874-4.8529 5.9969-6.4791 9.4813-1.5944 3.4165-2.6278 7.1055-2.928 10.869-0.26855 3.3677 0.060425 6.7791 1.0245 10.019 0.88257 2.962 0.5813 6.2767 0.75989 8.5619-0.31775 0.7373-0.99719 1.3348-1.5068 1.9513-0.51501 0.62292-1.0171 1.2582-1.4893 1.9149-0.94934 1.3208-1.7805 2.7384-2.3141 4.2803-1.0298 2.9746-0.75208 6.6222 1.5067 8.8146 1.2494 1.2129 2.9631 1.8557 4.6874 2.1044 0.75586 0.10938 1.5165 0.14795 2.2782 0.14795 0.65552 0 1.3118-0.028564 1.9658-0.065186 0.098145-0.0054932 0.19568-0.0079346 0.29309-0.0079346 0.6969 0 1.3781 0.12463 2.0847 0.12463 0.1095 0 0.2196-0.0029297 0.33044-0.0098877 1.4326-0.090332 2.8-0.41064 4.1296-0.94666 0.80237-0.3241 1.5846-0.69946 2.3593-1.0837 0.48853-0.24231 0.97449-0.48962 1.4603-0.73828 0.2738-0.14172 0.54883-0.28235 0.82239-0.42432 0.14514-0.075562 0.69214-0.46594 0.87146-0.46594 0.0084229 0 0.016113 8.5449e-4 0.022827 0.0026855 4.8701 1.337 9.9935 2.2036 15.089 2.2036 3.6945 0 7.3746-0.45581 10.931-1.5182 6.9574-2.078 12.883-6.5881 16.57-12.861 4.2402-7.2136 5.3514-15.855 4.8479-24.089-0.1532-2.5164-0.45972-5.0214-0.88538-7.505-0.10791-0.62769-0.22083-1.2556-0.34656-1.8798-0.16541-0.82349-0.31494-1.2203 0.16602-1.9648 0.40662-0.63159 0.79846-1.2772 1.16-1.9362 0.4231-0.76855 0.74084-1.567 1.0609-2.3807 0.79114-2.0103 2.1373-3.649 2.4912-5.835 0.35535-2.191-0.043701-4.5316-1.3032-6.3811-0.03772-0.056396-0.076538-0.11035-0.11572-0.16565-1.3395-1.8596-3.4592-3.0337-5.7117-3.4128-0.52991-0.089478-1.067-0.13489-1.6034-0.13489m0-6c0.87048 0 1.7423 0.073364 2.6024 0.21863 3.895 0.65564 7.3883 2.778 9.5812 5.8223 2.2621 3.3137 3.0883 7.2207 2.473 11.014-0.38171 2.3575-1.3289 4.1381-2.09 5.5687-0.25989 0.48877-0.53296 0.9751-0.74072 1.5029-0.41418 1.0531-0.83972 2.0813-1.3878 3.077-0.1637 0.29822-0.33301 0.59521-0.50696 0.8905l0.18445 0.9801c0.46301 2.7014 0.79468 5.4231 0.96106 8.157 0.65637 10.733-1.2494 19.984-5.6642 27.494-4.4094 7.5002-11.521 13.03-20.026 15.57-3.9294 1.174-8.1851 1.7692-12.648 1.7692-4.5334 0-9.3597-0.61292-14.376-1.8239l-1.2239 0.62122c-0.91162 0.45215-1.8339 0.89038-2.7782 1.2719-1.9392 0.78186-3.9564 1.2427-5.9993 1.3716-0.24133 0.0041504-0.45569 0.0061035-0.64832 0.0061035-0.80054 0-1.225-0.033081-1.6481-0.071289-1.2198 0.0036621-1.988 0.0354-2.7552 0.0354-1.0492 0-2.0964-0.059204-3.1375-0.20984-3.1934-0.46045-5.9634-1.7531-8.0074-3.7374-3.7368-3.627-4.9135-9.5474-2.9972-15.083 0.66882-1.933 1.6869-3.8367 3.1118-5.8192 0.55151-0.76709 1.1361-1.5093 1.7371-2.2362l0.061157 0.028809c-0.0015869-0.10449-0.0031738-0.20996-0.0047607-0.31616-0.024292-1.6685-0.049316-3.3937-0.4353-4.6893-1.1667-3.9203-1.5889-8.0273-1.2554-12.209 0.35034-4.3933 1.5184-8.7433 3.4718-12.929 1.8916-4.053 4.4365-7.7789 7.5642-11.074 3.1807-3.3523 6.8243-6.1112 10.829-8.1998 4.2383-2.2103 8.7349-3.5889 13.365-4.0972 0.025269-0.0028076 1.1218-0.081421 1.1472-0.083862 0.35254-0.1261 1.0731-0.36279 1.443-0.42114 1.3706-0.21313 2.7451-0.31738 4.1187-0.31738 4.3562 0.13818 7.6383 0.8783 10.718 2.2168l1.1827 0.53491c0.69165 0.31946 1.7369 0.80237 2.1195 0.84546-0.26746-0.035156 0.39392-0.6416 0.83154-1.043 0.80286-0.73621 1.6201-1.4615 2.4943-2.0732 2.3918-1.6759 5.2744-2.5627 8.3333-2.5627z",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.966 -.259 .259 .966 238.57 807.13)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#eddd36",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m13.192 74.009c-0.50526 1.5259e-5 -0.95115-0.040009-1.3445-0.075333-0.26734-0.024002-0.51985-0.046677-0.70435-0.046677-0.033925 0-0.064762 7.782e-4 -0.09165 0.0022964-0.58119 0.032532-1.3469 0.069725-2.1339 0.069725-1.0028 1.5259e-5 -1.9017-0.059456-2.7481-0.18182-2.6426-0.38116-4.9107-1.4281-6.5579-3.0275-1.6073-1.5599-2.6396-3.6591-2.9848-6.0703-0.29511-2.0612-0.077175-4.231 0.63023-6.2747 0.58244-1.683 1.4808-3.3573 2.7464-5.1183 0.45841-0.63779 0.96996-1.2962 1.61-2.0722l0.0016125-0.0019608 0.0016249-0.0019646c0.19214-0.23226 0.38414-0.44307 0.55354-0.62906 0.023836-0.026169 0.049521-0.054371 0.076174-0.083744-0.01005-0.37165-0.01556-0.75195-0.021211-1.1422-0.025-1.7252-0.053338-3.6805-0.52946-5.2783-1.0648-3.577-1.4498-7.3291-1.1447-11.153 0.32241-4.0419 1.4002-8.0512 3.2034-11.917 1.7542-3.7576 4.1158-7.2145 7.0196-10.275 2.9531-3.1124 6.3315-5.6708 10.042-7.6043 3.9134-2.0407 8.0591-3.3127 12.321-3.7802 0.27781-0.030638 0.53012-0.044263 0.75275-0.056288 0.12725-0.0068755 0.29596-0.015993 0.38136-0.025798 0.043514-0.014509 0.11218-0.03906 0.16557-0.058152 0.31092-0.1112 0.78081-0.27924 1.3673-0.37154 1.2034-0.18827 2.4397-0.2835 3.6777-0.2835 0.28721 0 0.57884 0.0051625 0.8668 0.01535 3.0456 0.10886 5.9861 0.77121 8.7413 1.9687 0.38191 0.16612 0.75352 0.33794 1.1129 0.5041 1.1219 0.51873 2.282 1.0551 3.0511 1.0551h2.0981e-4c0.094868 0 0.18047-0.0084379 0.26169-0.025763 0.59946-0.12752 1.3979-0.85994 2.2433-1.6354 0.64222-0.58909 1.3701-1.2568 2.2113-1.8455 1.9525-1.3667 4.3155-2.0891 6.8332-2.0891 0.71926 0 1.4455 0.060825 2.1585 0.1808 3.2205 0.54229 6.096 2.2813 7.8896 4.7712 0.057777 0.080238 0.11312 0.15911 0.16495 0.23505 1.6844 2.4737 2.3575 5.6887 1.8487 8.8238-0.31265 1.9309-1.1078 3.4255-1.8094 4.7442-0.32375 0.6085-0.62954 1.1833-0.84453 1.7292-0.32879 0.83544-0.70171 1.783-1.237 2.7546-0.28056 0.51087-0.58446 1.0287-0.92068 1.5684 0.10954 0.55133 0.21786 1.1415 0.33916 1.8476 0.45599 2.6602 0.76439 5.2766 0.91685 7.7777 0.28313 4.6311 0.052322 9.0358-0.68605 13.091-0.85224 4.6806-2.3896 8.934-4.5692 12.642-4.0346 6.8648-10.551 11.929-18.35 14.259-3.6489 1.09-7.6106 1.6426-11.776 1.6426-4.5351 6.8665e-5 -9.396-0.65339-14.467-1.9436-0.16774 0.086624-0.33564 0.17313-0.50304 0.25906-0.57122 0.29391-1.0432 0.533-1.4826 0.75095-0.74645 0.37019-1.6353 0.79934-2.5713 1.1771-1.663 0.67215-3.3997 1.0696-5.1603 1.1807-0.1776 0.011299-0.36401 0.017082-0.55226 0.017082z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m64.803 3.8147e-5c-1.7132 0-3.4165 0.4698-4.8263 1.4566-1.9348 1.3541-3.4213 3.5449-5.7309 4.0362-0.33228 0.070908-0.66302 0.10284-0.99251 0.10284-1.9031 0-3.759-1.0663-5.559-1.8493-2.3553-1.0237-4.9053-1.5891-7.4698-1.6808-0.24765-0.0087585-0.49532-0.013161-0.74325-0.013161-1.0482 7.6294e-6 -2.0974 0.07885-3.1335 0.24095-0.47155 0.074211-0.85889 0.28844-1.312 0.38976-0.48645 0.10779-1.0225 0.089104-1.5175 0.14368-3.8693 0.42442-7.6369 1.6067-11.085 3.4049-3.3989 1.7714-6.4834 4.1306-9.1199 6.9093-2.6079 2.749-4.7841 5.9127-6.387 9.3462-1.5718 3.3693-2.5905 7.0059-2.8863 10.715-0.26489 3.3196 0.059448 6.6815 1.01 9.8749 0.8701 2.9199 0.57313 6.1875 0.74902 8.4415-0.31324 0.72521-0.98279 1.3146-1.4855 1.9222-0.50745 0.61524-1.0024 1.2401-1.4679 1.8877-0.93579 1.3021-1.7551 2.7007-2.2811 4.2206-1.015 2.9324-0.74145 6.5281 1.4852 8.6891 1.2316 1.1958 2.9211 1.8295 4.6206 2.0746 0.74554 0.1078 1.4959 0.14582 2.2471 0.14582 0.64572 0 1.2922-0.028107 1.9364-0.064156 0.096767-0.0054703 0.1931-0.0078735 0.28914-0.0078735 0.68504 0 1.3544 0.12204 2.0489 0.12204 0.10992 0 0.22051-0.0030594 0.33184-0.010147 1.4122-0.089127 2.7601-0.40357 4.0709-0.93336 0.79102-0.31921 1.5622-0.6881 2.3257-1.0668 0.48158-0.23889 0.96058-0.48279 1.4396-0.72926 0.26989-0.13853 0.54103-0.27855 0.81079-0.41821 0.14289-0.073227 0.68096-0.45834 0.85826-0.45834 0.008564 0 0.016315 9.0027e-4 0.023113 0.0027771 4.8016 1.3176 9.8529 2.172 14.877 2.172 3.6412 0 7.2683-0.44907 10.774-1.4961 6.8585-2.0496 12.699-6.4945 16.335-12.68 4.1799-7.1108 5.2754-15.628 4.7791-23.746-0.15113-2.4791-0.45313-4.9497-0.87282-7.3981-0.10632-0.61892-0.21777-1.2365-0.34155-1.8531-0.16331-0.812-0.31079-1.203 0.16344-1.937 0.401-0.62135 0.78724-1.2587 1.1436-1.9075 0.41724-0.75732 0.73024-1.5459 1.0459-2.348 0.77976-1.9803 2.1067-3.5957 2.4558-5.7518 0.35034-2.1586-0.043312-4.4671-1.2848-6.2902-0.037209-0.054573-0.075546-0.10902-0.11389-0.16223-1.3205-1.8331-3.41-2.9916-5.6305-3.3655-0.52156-0.087753-1.05-0.13229-1.5779-0.13229m-7.6294e-6 -7c0.91645 0 1.8339 0.076973 2.7394 0.22934 4.122 0.69408 7.8207 2.9454 10.149 6.1769 2.4016 3.5174 3.2795 7.6549 2.6286 11.665-0.40511 2.5021-1.4277 4.424-2.1743 5.8274-0.23692 0.44529-0.48847 0.88684-0.67779 1.3676-0.42574 1.0818-0.86485 2.1389-1.4281 3.1613-0.10055 0.18309-0.2033 0.36593-0.30795 0.54827l0.11037 0.58631c0.46303 2.7011 0.79431 5.4246 0.96089 8.1572 0.66029 10.8-1.268 20.127-5.7314 27.72-4.4841 7.6295-11.717 13.255-20.365 15.839-3.9748 1.1873-8.2736 1.7892-12.778 1.7892-4.436 0-9.1459-0.5827-14.036-1.7346l-0.86163 0.43642c-0.92463 0.45857-1.8596 0.90102-2.8169 1.2873-2.0098 0.81232-4.1137 1.2933-6.2495 1.4281-0.27327 0.0049286-0.51376 0.0071564-0.72794 0.0071564-0.83021 0-1.2669-0.033417-1.7023-0.072495-1.0638 0.0076065-1.8409 0.039368-2.6171 0.039368-1.0863 0-2.1707-0.062004-3.2488-0.21784-3.3766-0.487-6.3151-1.8635-8.4953-3.9804-3.984-3.8666-5.2499-10.148-3.2239-16.001 0.69482-2.0077 1.7454-3.9757 3.2117-6.016 0.49771-0.69251 1.0223-1.3642 1.5615-2.0244-0.021553-1.4508-0.057571-3.0562-0.38135-4.1428-1.1887-3.9934-1.6189-8.1751-1.2793-12.431 0.35571-4.4593 1.5402-8.8728 3.5205-13.118 1.9144-4.1006 4.4887-7.8698 7.6523-11.205 3.2204-3.3942 6.9088-6.1863 10.963-8.2992 4.2996-2.2421 8.8614-3.6405 13.557-4.1556l0.088814-0.0097427 1.0691-0.074867c-0.015343-0.10092 0.63542-0.29355 1.3466-0.40547 1.4001-0.21906 2.8116-0.32605 4.2217-0.32605 4.477 0.14216 7.8448 0.90134 11.003 2.2741l1.1868 0.53726c0.34207 0.15814 0.78578 0.3633 1.1615 0.52004 0.18749-0.1713 0.36979-0.3541 0.55991-0.52849 0.82682-0.75842 1.6701-1.5037 2.5703-2.1337 2.5436-1.7804 5.6006-2.7216 8.84-2.7216z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-7.375 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.035 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(7.305 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(14.645 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(21.985 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(29.325 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(36.665 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.005 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(51.345 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(58.685 -3.555)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.705 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.635 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(10.975 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.315 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.655 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(32.995 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(40.335 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.675 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(55.015 2.06)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(62.355 2.061)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-7.375 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.035 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(7.305 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(14.645 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(21.985 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(29.325 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(36.665 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.005 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(51.345 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(58.685 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.025 7.675)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.705 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.635 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(10.975 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.315 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.655 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(32.995 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(40.335 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.675 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(55.015 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(62.355 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.695 13.29)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-7.375 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.035 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(7.305 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(14.645 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(21.985 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(29.325 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(36.665 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.005 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(51.345 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(58.685 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.025 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(73.365 18.905)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.705 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.635 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(10.975 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.315 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.655 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(32.995 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(40.335 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.675 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(55.015 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(62.355 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.695 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(77.035 24.52)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-7.375 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.035 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(7.305 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(14.645 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(21.985 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(29.325 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(36.665 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.005 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(51.345 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(58.685 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.025 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(73.365 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(80.705 30.135)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.705 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.635 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(10.975 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.315 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.655 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(32.995 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(40.335 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.675 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(55.015 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(62.355 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.695 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(77.035 35.75)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-7.375 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.035 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(7.305 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(14.645 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(21.985 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(29.325 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(36.665 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.005 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(51.345 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(58.685 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.025 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(73.365 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(80.705 41.365)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.705 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.635 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(10.975 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.315 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.655 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(32.995 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(40.335 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.675 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(55.015 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(62.355 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.695 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(77.035 46.98)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-7.375 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.035 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(7.305 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(14.645 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(21.985 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(29.325 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(36.665 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.005 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(51.345 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(58.685 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.025 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(73.365 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(80.705 52.595)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.705 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.635 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(10.975 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.315 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.655 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(32.995 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(40.335 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.675 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(55.015 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(62.355 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.695 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(77.035 58.21)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-7.375 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.035 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(7.305 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(14.645 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(21.985 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(29.325 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(36.665 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.005 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(51.345 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(58.685 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.025 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(73.365 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(80.705 63.825)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.705 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.635 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(10.975 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.315 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.655 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(32.995 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(40.335 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.675 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(55.015 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(62.355 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.695 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(77.035 69.44)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.323 -3.58)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(73.663 -3.58)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(81.003 -3.58)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.993 2.035)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(77.333 2.035)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(73.663 7.65)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(81.003 7.65)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(77.333 13.265)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(81.003 18.88)",
    cx: 1.78,
    cy: 1.78,
    rx: 1.78,
    ry: 1.78
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(125 807.22) rotate(-59)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1248.3 -1224.6)",
    fill: "#eddd36",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    d: "m1259.7 1289c-0.45789 0-0.87158-0.037231-1.2041-0.067017-0.21997-0.019775-0.42773-0.038452-0.5658-0.038452-0.020264 0-0.037842 4.8828e-4 -0.052246 0.0012207-0.50854 0.028442-1.1785 0.061035-1.8701 0.061035-0.8894 0-1.6884-0.052979-2.4423-0.16199-2.3829-0.34375-4.4335-1.293-5.9288-2.745-1.4647-1.4216-2.4049-3.33-2.7181-5.5182-0.26562-1.8553-0.069946-3.807 0.56592-5.6437 0.51819-1.4978 1.3149-2.9841 2.4355-4.5436 0.40369-0.56128 0.85156-1.1378 1.4105-1.8153 0.15173-0.18359 0.29907-0.34766 0.43298-0.495-0.0058594-0.26184-0.0097656-0.52832-0.013672-0.80029-0.021118-1.4594-0.045044-3.1135-0.4375-4.4305-0.93665-3.1466-1.2754-6.4463-1.0071-9.8082 0.28308-3.5486 1.2286-7.067 2.8104-10.458 1.5371-3.2927 3.6061-6.3214 6.1498-9.0027 2.5872-2.7267 5.5477-4.9686 8.7997-6.6633 3.433-1.7903 7.0708-2.9064 10.812-3.3168 0.25317-0.027954 0.48816-0.040527 0.67688-0.050781 0.081055-0.0043945 0.18433-0.0098877 0.25342-0.015503 0.0271-0.0095215 0.057617-0.020386 0.083252-0.029663 0.28564-0.10217 0.71716-0.25647 1.2684-0.34326 1.0642-0.16638 2.1565-0.25061 3.2498-0.25061 0.25427 0 0.51233 0.0046387 0.76721 0.013672 2.6903 0.096069 5.2887 0.6814 7.7238 1.7399 0.33496 0.14563 0.65881 0.29541 0.97205 0.44019 0.87915 0.40637 1.8756 0.86707 2.4351 0.86707 0.048218 0 0.089722-0.0037842 0.12683-0.011719 0.39062-0.08313 1.1249-0.75659 1.7147-1.2977 0.56567-0.5188 1.2068-1.1069 1.9591-1.6335 1.7675-1.2369 3.9031-1.8907 6.176-1.8907 0.64783 0 1.3018 0.05481 1.9438 0.16284 2.9045 0.48889 5.5006 2.0609 7.1229 4.313 0.054199 0.075317 0.10388 0.146 0.151 0.21521 1.5216 2.2344 2.131 5.1373 1.6721 7.965-0.28259 1.7456-1.0201 3.1318-1.6127 4.2456-0.27319 0.51331-0.53113 0.99817-0.70691 1.4445-0.27502 0.69885-0.61755 1.5692-1.0944 2.4348-0.21875 0.39819-0.45337 0.80078-0.70923 1.2168 0.08313 0.42725 0.16675 0.88684 0.25891 1.4232 0.39697 2.3158 0.66528 4.5933 0.79797 6.7708 0.24683 4.0386 0.045166 7.8821-0.59949 11.423-0.74622 4.0985-2.0938 7.8253-4.005 11.077-3.5464 6.0341-9.2732 10.485-16.125 12.533-3.1964 0.95483-6.6646 1.4388-10.309 1.439-3.9047 0-8.0831-0.55432-12.439-1.6492-0.091797 0.047241-0.18347 0.09436-0.2749 0.14136-0.50037 0.25732-0.90991 0.46472-1.2866 0.65161-0.65369 0.32422-1.4321 0.69995-2.2545 1.0319-1.4839 0.59973-3.0341 0.95447-4.606 1.0537-0.16345 0.010376-0.33459 0.015747-0.50708 0.015747z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m1304.3 1224.6c-1.48 0-2.9512 0.40576-4.1691 1.2582-1.6714 1.1698-2.9553 3.0624-4.9506 3.4868-0.28687 0.061157-0.57263 0.088745-0.85718 0.088745-1.644 0-3.2472-0.92114-4.8022-1.5974-2.0347-0.8844-4.2373-1.3728-6.4526-1.4519-0.21423-0.0075684-0.42859-0.011475-0.64294-0.011475-0.90527 0-1.8112 0.068237-2.7059 0.20813-0.40735 0.064087-0.74194 0.24915-1.1333 0.33679-0.42029 0.093018-0.8833 0.076904-1.3109 0.12402-3.3424 0.3667-6.5969 1.3879-9.5758 2.9414-2.936 1.5302-5.6006 3.5681-7.8781 5.9685-2.2528 2.3746-4.1326 5.1075-5.5172 8.0735-1.3578 2.9104-2.2377 6.0519-2.4933 9.2562-0.22888 2.8677 0.05127 5.7717 0.87244 8.5303 0.75159 2.5223 0.495 5.345 0.64685 7.2921-0.27051 0.62646-0.84888 1.1355-1.2831 1.6605-0.43835 0.53137-0.86597 1.0713-1.2681 1.6305-0.80835 1.1249-1.5161 2.333-1.9705 3.646-0.87683 2.533-0.6405 5.639 1.283 7.5059 1.0638 1.033 2.5233 1.5803 3.9915 1.7921 0.64404 0.09314 1.2925 0.12598 1.9415 0.12598 0.55774 0 1.116-0.024292 1.6724-0.05542 0.08374-0.0047607 0.16699-0.0068359 0.25-0.0068359 0.59167 0 1.1698 0.10547 1.7698 0.10547 0.094971 0 0.19043-0.0026855 0.28662-0.0087891 1.2198-0.077026 2.3843-0.34863 3.5166-0.80627 0.68323-0.27576 1.3494-0.59448 2.0089-0.92151 0.41602-0.20642 0.82971-0.41711 1.2437-0.63 0.23303-0.11963 0.46716-0.24048 0.70032-0.36121 0.12341-0.063232 0.58838-0.396 0.74133-0.396 0.0073242 0 0.014038 8.5449e-4 0.019897 0.0024414 4.1478 1.1381 8.5115 1.8762 12.851 1.8762 3.1454 0 6.2784-0.38794 9.3064-1.2924 5.9246-1.7706 10.97-5.6102 14.11-10.953 3.6107-6.1427 4.557-13.5 4.1283-20.513-0.13049-2.1416-0.39136-4.2758-0.75378-6.3906-0.091919-0.53467-0.18823-1.0682-0.29517-1.6007-0.14111-0.70154-0.26843-1.0392 0.14124-1.6733 0.34644-0.53674 0.68005-1.0873 0.98792-1.6477 0.36035-0.65417 0.63074-1.3354 0.90344-2.0283 0.67358-1.7107 1.8198-3.1061 2.1213-4.9685 0.30261-1.8647-0.037354-3.8589-1.1099-5.4338-0.032104-0.047119-0.065308-0.094116-0.098389-0.14001-1.1407-1.5836-2.9457-2.5844-4.8638-2.9072-0.45056-0.075806-0.9071-0.11426-1.363-0.11426m0-7c0.8446 0 1.6901 0.070923 2.5247 0.2113 3.806 0.64062 7.2255 2.7251 9.382 5.7188 2.2249 3.2583 3.0389 7.0836 2.4381 10.786-0.37512 2.317-1.3014 4.0579-1.9777 5.329-0.18787 0.35303-0.39001 0.70178-0.54004 1.0829-0.38281 0.97253-0.7793 1.9224-1.2855 2.8413-0.033081 0.060181-0.066406 0.12024-0.099854 0.1803l0.033447 0.17786c0.40588 2.3689 0.69604 4.7559 0.84204 7.1509 0.58203 9.5217-1.1273 17.76-5.0807 24.486-3.9958 6.7986-10.438 11.811-18.141 14.113-3.5223 1.052-7.3275 1.5853-11.311 1.5853-3.802 0-7.8289-0.48523-12.003-1.4446l-0.44165 0.22375c-0.82166 0.40735-1.6512 0.79956-2.5004 1.1422-1.8311 0.73999-3.7483 1.1782-5.6954 1.3011-0.26318 0.0047607-0.49329 0.006958-0.69714 0.006958-0.75671 0-1.153-0.029907-1.5477-0.065308-0.79797 0.0098877-1.4868 0.037842-2.175 0.037842-0.98401 0-1.9666-0.056885-2.9431-0.198-3.1169-0.44971-5.8378-1.7285-7.8662-3.698-3.7058-3.5968-4.8923-9.4135-3.0215-14.818 0.63062-1.8225 1.5796-3.6025 2.9009-5.4413 0.37378-0.51978 0.76392-1.0259 1.1644-1.5236-0.019653-1.0931-0.064453-2.2379-0.28418-2.9756-1.0607-3.5629-1.4446-7.2921-1.1417-11.086 0.31641-3.9661 1.3687-7.8888 3.1274-11.659 1.6974-3.6357 3.979-6.9767 6.7825-9.9318 2.8545-3.0085 6.1251-5.4841 9.7212-7.3583 3.8192-1.9917 7.873-3.2341 12.048-3.6921l0.1145-0.012573 0.91443-0.063232c-0.20422-0.054077 0.41479-0.23535 1.0909-0.34167 1.2584-0.1969 2.5266-0.29321 3.7937-0.29321 4.022 0.12769 7.0477 0.80994 9.8861 2.0437l0.073853 0.031982 0.97168 0.44116c0.13428 0.062012 0.26782 0.12781 0.40137 0.19275 0.013428-0.012451 0.026978-0.024902 0.040527-0.037354 0.74524-0.68372 1.5067-1.354 2.3182-1.9219 2.3586-1.6508 5.1882-2.5233 8.1829-2.5233z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-6.371 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.03 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(6.31 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(12.651 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.991 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.332 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(31.672 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(38.013 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.354 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(50.694 -3.071)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.201 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.14 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(9.48 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(15.821 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(22.162 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(28.502 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(34.843 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(41.183 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.524 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(53.864 1.78)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-6.371 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.03 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(6.31 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(12.651 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.991 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.332 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(31.672 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(38.013 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.354 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(50.694 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(57.035 6.63)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.201 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.14 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(9.48 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(15.821 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(22.162 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(28.502 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(34.843 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(41.183 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.524 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(53.864 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(60.205 11.481)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-6.371 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.03 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(6.31 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(12.651 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.991 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.332 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(31.672 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(38.013 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.354 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(50.694 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(57.035 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(63.375 16.331)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.201 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.14 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(9.48 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(15.821 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(22.162 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(28.502 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(34.843 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(41.183 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.524 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(53.864 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(60.205 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.546 21.181)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-6.371 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.03 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(6.31 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(12.651 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.991 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.332 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(31.672 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(38.013 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.354 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(50.694 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(57.035 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(63.375 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.716 26.032)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.201 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.14 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(9.48 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(15.821 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(22.162 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(28.502 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(34.843 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(41.183 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.524 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(53.864 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(60.205 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.546 30.882)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-6.371 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.03 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(6.31 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(12.651 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.991 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.332 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(31.672 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(38.013 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.354 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(50.694 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(57.035 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(63.375 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.716 35.733)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.201 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.14 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(9.48 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(15.821 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(22.162 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(28.502 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(34.843 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(41.183 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.524 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(53.864 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(60.205 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.546 40.583)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-6.371 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.03 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(6.31 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(12.651 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.991 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.332 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(31.672 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(38.013 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.354 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(50.694 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(57.035 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(63.375 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.716 45.434)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.201 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.14 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(9.48 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(15.821 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(22.162 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(28.502 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(34.843 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(41.183 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.524 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(53.864 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(60.205 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.546 50.284)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-6.371 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-.03 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(6.31 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(12.651 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(18.991 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(25.332 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(31.672 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(38.013 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(44.354 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(50.694 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(57.035 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(63.375 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.716 55.134)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(-3.201 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(3.14 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(9.48 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(15.821 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(22.162 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(28.502 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(34.843 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(41.183 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(47.524 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(53.864 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(60.205 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.546 59.985)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(57.291 -3.092)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(63.632 -3.092)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.973 -3.092)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(60.462 1.758)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.802 1.758)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(63.632 6.608)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.973 6.608)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(66.802 11.459)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "translate(69.973 16.309)",
    cx: 1.538,
    cy: 1.538,
    rx: 1.538,
    ry: 1.538
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLimones);
export default __webpack_public_path__ + "static/media/limones.00d8089d6ff197134e0d397ec526ed11.svg";
export { ForwardRef as ReactComponent };